import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatNumber, formatNumberForIntegralPart } from '../../../utils/number';
// import margin from '../../../actions/actionsSet/margin';

const VoteResult = styled.div`
  position: relative;
  margin-bottom: 30px;
  background: #fff;
  text-align: center;
  padding: 24px 30px;
  border-radius: 3px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);

  .inline-block {
    display: inline-block;
    margin: 0 auto;

    > ul {
      margin-bottom: 8px;
    }
  }

  .vote-tle {
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    margin-right: 20px;
    font-weight: 500;
  }

  .vote-cot {
    align-items: center;
    display: flex;
    font-size: 14px;

    .bnb-info {
      font-size: 16px;

      > strong {
        font-weight: normal;
      }
    }

    > a {
      font-size: 14px;
      color: #f0b90b;
      margin-left: 20px;
    }
  }

  .vote-ext {
    display: flex;
    align-items: center;
    list-style: none;
    text-align: left;

    > li {
      font-size: 14px;
      line-height: 30px;

      &:last-of-type {
        margin-right: 0;

        &::before {
          position: relative;
          content: 'or';
          margin: 0 25px;
          color: #848e9c;
        }
      }

      &.bnb-info {
        font-size: 16px;
        flex-wrap: nowrap;
        align-items: flex-start;

        > strong {
          font-weight: normal;
          text-align: left;

          > span {
            color: #48515d;
            font-family: ${({ theme }) => theme.fontIBMRegular};
            font-size: 14px;
            margin-right: 4px;
          }
        }
        > img {
          width: 26px;
          height: 26px;
          margin-right: 8px;
        }
      }
    }
  }

  @media screen and (max-width: 414px) {
    .vote-tle {
      width: 100%;
      margin-bottom: 6px;
    }

    .vote-ext > li.bnb-info {
      margin: 0 0 8px 0;

      &::before {
        content: none !important;
      }
    }

    .vote-ext,
    .vote-cot {
      flex-wrap: wrap;

      > a {
        position: absolute;
        top: 24px;
        right: 30px;
      }
    }
  }
`;

const VoteResultCenter = styled.div`
  display: flex;
  margin-bottom: 30px;
  background: #fff;
  padding: 24px 30px;
  border-radius: 3px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  justify-content: center;
  flex-wrap: wrap;
  min-height: 113px;

  .vt-res {
    margin-bottom: 0;
    padding: 16px 30px;
    background: rgba(234, 236, 239, 0.6);
    width: 100%;
  }

  .res-tel {
    display: flex;
    align-items: center;
    font-weight: normal;
    padding: 10px;
    font-size: 22px;
    text-align: center;
  }

  .profit-list {
    margin-bottom: 20px;
    line-height: 28px;

    .res-tel {
      text-align: left;
      display: inline;
      padding: 0;
    }

    .bnb-info {
      display: inline;
      font-size: 24px;
    }
  }

  @media screen and (max-width: 414px) {
    padding-left: 16px;
    padding-right: 16px;

    .res-tel {
      font-size: 14px;
    }

    .vt-res {
      padding: 8px 16px;
      .vote-cot > a {
        top: 8px;
        right: 16px;
      }
    }
    .profit-list .bnb-info {
      font-size: 18px;
    }
  }
`;

const { object, string, bool } = PropTypes;

const bnbLogoUrl = 'https://bin.bnbstatic.com/static/images/home/coin-logo/BNB.png';

const scrollToRule = () => {
  const ruleTerm = document.querySelector('#rule-term');
  if (ruleTerm instanceof Element) {
    const { top } = ruleTerm.getBoundingClientRect();
    window.scrollTo(0, top);
  }
};

const Reward = ({
  language, project, locale, isLoggedIn, nextLink,
}) => {
  const {
    options = [],
    rule: { bnbReward, rdrop },
    product: { status },
    profit,
  } = project || {};

  if (rdrop !== 1 || ['2', '3', '4'].indexOf(`${status}`) === -1) return null;

  const {
    winnerTle,
    nextTle,
    profitTitle,
    profitExt,
    rule: nextRule,
    success: successText,
    runnerText,
    fail: failText,
  } = language || {};

  const { bnbProfit, optionCoin, optionProfit } = profit || {};

  const voteResult = (
    <VoteResult maxWidth={locale === 'cn' ? 121 : 61} className="vt-res">
      <div className="inline-block">
        <ul className="vote-ext">
          <span className="vote-tle">{winnerTle}</span>
          {options.map((item, key) => (
            <li className="bnb-info" key={key}>
              <img src={item.coinImg} alt="" />
              <strong>
                <span>{profitExt.replace(/@1/gi, item.coin)}: </span>
                {`${formatNumber(item.reward)} ${item.coin}`}
              </strong>
            </li>
          ))}
        </ul>
        <div className="vote-cot">
          {bnbReward > 0 ? (
            <React.Fragment>
              <span className="vote-tle">{nextTle}</span>
              <span style={{ marginRight: '4px' }}>{profitTitle}</span>
              <div className="bnb-info">
                <img src={bnbLogoUrl} alt="" />
                <strong>{`${formatNumber(bnbReward)} ${'BNB'}`}</strong>
              </div>
              {nextLink ? (
                <a href={nextLink} target="_blank" rel="noopener noreferrer nofollow">
                  {nextRule}
                </a>
              ) : (
                <a onClick={scrollToRule}>{nextRule}</a>
              )}
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </VoteResult>
  );

  if (['2', '3'].indexOf(`${status}`) > -1 || !isLoggedIn) return voteResult;

  const [profitObject] = options
    .map(opts => ({
      ...opts,
      profit: opts.coin === optionCoin ? optionProfit : 0,
      isTrue: opts.coin === optionCoin,
    }))
    .filter(v => v.isTrue);

  const nextProfit = bnbProfit
    ? {
      profit: bnbProfit,
      coinImg: bnbLogoUrl,
      coin: 'BNB',
    }
    : profitObject;

  if (nextProfit && !!nextProfit.profit) {
    return (
      <VoteResultCenter>
        <div className="profit-list">
          <b className="res-tel">{bnbProfit ? runnerText : successText}</b>
          <div className="bnb-info">
            <img src={nextProfit.coinImg} alt="" />
            {`${formatNumberForIntegralPart(nextProfit.profit)} ${nextProfit.coin}`}
          </div>
        </div>
        {voteResult}
      </VoteResultCenter>
    );
  }

  return (
    <VoteResultCenter alignItems="center">
      <b className="res-tel">{failText}</b>
    </VoteResultCenter>
  );
};

Reward.propTypes = {
  project: object,
  language: object,
  locale: string,
  isLoggedIn: bool,
  nextLink: string,
};

export default React.memo(Reward);
